import cssModule from "@vercel/turbopack-next/internal/font/google/cssmodule.module.css?{%22path%22:%22layout.tsx%22,%22import%22:%22Noto_Sans_Arabic%22,%22arguments%22:[{%22variable%22:%22--font-noto-arabic%22,%22subsets%22:[%22arabic%22],%22weight%22:[%22400%22,%22500%22,%22600%22,%22700%22]}],%22variableName%22:%22notoSansArabic%22}";
const fontData = {
    className: cssModule.className,
    style: {
        fontFamily: "'Noto Sans Arabic', 'Noto Sans Arabic Fallback'",
        fontStyle: "normal",

    },
};

if (cssModule.variable != null) {
    fontData.variable = cssModule.variable;
}

export default fontData;
